import { Box, Divider, Typography } from '@mui/material';
import {
  LABEL_CONTACT_US_SUBTITLE,
  LABEL_CONTACT_US_TITLE,
  LABEL_CONTACT_INFORMATION,
  LABEL_EMAIL,
  LABEL_PHONE,
  WDIC_SUPPORT_EMAIL,
  WDIC_SUPPORT_PHONE,
} from '../../../../shared/lib/constants';
import { userDetailsWrapper } from '../../../../shared/lib/theme/styleConstants';
import palette from '../../../../shared/lib/theme/palette';

export const ContactInformation = () => {
  const { blackOne, blackTwo, primary } = palette;

  return (
    <Box marginTop="16px">
      <Typography variant="h5" sx={{ color: blackOne, fontWeight: 600, mb: 0.5 }}>
        {LABEL_CONTACT_US_TITLE}
      </Typography>

      <Typography variant="body2" sx={{ color: blackTwo, mb: 3 }}>
        {LABEL_CONTACT_US_SUBTITLE}
      </Typography>

      <Divider sx={{ mb: 3 }} />

      <Box sx={{ ...userDetailsWrapper, maxWidth: 600 }}>
        <Typography variant="h6" sx={{ fontWeight: 700, color: blackOne, mb: 2 }}>
          {LABEL_CONTACT_INFORMATION}
        </Typography>

        <Box mb={2}>
          <Typography variant="body2" sx={{ color: blackTwo, fontWeight: 600, mb: 0.5 }}>
            {LABEL_PHONE}
          </Typography>
          <Typography variant="body2" sx={{ color: primary.main, fontWeight: 600 }}>
            {WDIC_SUPPORT_PHONE}
          </Typography>
        </Box>

        <Box>
          <Typography variant="body2" sx={{ color: blackTwo, fontWeight: 600, mb: 0.5 }}>
            {LABEL_EMAIL}
          </Typography>
          <Typography
            component="a"
            href={`mailto:${WDIC_SUPPORT_EMAIL}`}
            variant="body2"
            sx={{ color: primary.main, fontWeight: 600, textDecoration: 'none' }}
          >
            {WDIC_SUPPORT_EMAIL}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
